<script>
export default {
  name: 'NotificationComponent',
  computed: {
    noNotifications() {
      return !this.$store.getters['user/notifications']
        || this.$store.getters['user/notifications'].length === 0;
    },
  },
  methods: {
    /**
     * Convert a notification level to a bootstrap display variant
     */
    levelToVariant(level) {
      if (level === 'INFO') return 'info';
      if (level === 'WARN') return 'warning';
      if (level === 'ALERT') return 'danger';
      return 'info';
    },
    /**
     * Convert a notification level to a toaster title
     */
    levelToTitle(level) {
      if (level === 'INFO') return 'Info';
      if (level === 'WARN') return 'Warning';
      if (level === 'ALERT') return 'Alert';
      return 'Info';
    },
    /**
     * Dismiss a notification
     */
    dismissNotification(index) {
      this.$store.dispatch('user/dismissNotification', index);
    },
  },
};
</script>
<template>
  <div>
    <div
      v-for="(notification, i) in $store.getters['user/notifications']"
      :key="i"
      class="toast show toast-notification"
      role="status"
      aria-live="polite"
      aria-atomic="true"
      style="margin-left: auto; margin-right: auto;"
    >
      <div class="toast-header">
        <strong class="me-auto">
          {{ levelToTitle(notification.level) }}
        </strong>
      </div>

      <div class="toast-body">
        <BRow
          no-gutters
          align-v="center"
        >
          <BCol>
            {{ notification.message }}
          </BCol>

          <BCol
            cols="auto"
            align-h="end"
          >
            <BButton
              size="sm"
              :variant="levelToVariant(notification.level)"
              @click="dismissNotification(i)"
            >
              Dismiss
            </BButton>
          </BCol>
        </BRow>
      </div>
    </div>

    <p
      v-if="noNotifications"
      class="lead text-muted text-center"
    >
      No Notifications to Show
    </p>
  </div>
</template>

<style scoped>
.toast-notification {
  margin-left: auto;
  margin-right: auto;
}
</style>

